import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// @/views
const HowCanIPay = () => import('@/views/help/HowCanIPay.vue');
const HaveQuestion = () => import('@/views/help/HaveQuestion.vue');
const ContactUs = () => import('@/views/ContactUs.vue');
const FAQ = () => import('@/views/help/FAQ.vue');
const PRAC = () => import('@/views/help/PRAC.vue');
const PracEnergy = () => import('@/views/help/PracEnergy.vue');
const SeekAdvice = () => import('@/views/SeekAdvice.vue');
const Help = () => import('@/views/Help.vue');
const PageNotFound = () => import('@/views/PageNotFound.vue');
const Thanks = () => import('@/views/Thanks.vue');
const Accreditations = () => import('@/views/Accreditations.vue');
const Chat = () => import('@/views/help/Chat.vue');
const HMRC = () => import('@/views/HMRC.vue');
// @/views/Disclaimers
const Accessibility = () => import('@/views/Disclaimers/Accessibility.vue');
const Privacy = () => import('@/views/Disclaimers/Privacy.vue');
const TermsOfUse = () => import('@/views/Disclaimers/TermsOfUse.vue');
const Complaints = () => import('@/views/Disclaimers/Complaints.vue');
// @/views/Help
const AboutUs = () => import('@/views/AboutUs.vue');
const NextSteps = () => import('@/views/NextSteps.vue');
// @/views/Home
const Home = () => import('@/views/Home.vue');
const CustomerPortalInternal = () => import('@/views/CustomerPortal.vue');

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      metaTags: [
        {
          name: 'description',
          content: 'BW Legal We are instructed by various clients in matters relating to debt recovery. We are here to help you manage your outstanding balance in a simple and affordable way and we will support you through every step of the process.'
        }
      ],
      title: 'BW Legal'
    }
  },
  {
    path: '/home',
    redirect: { path: '/' }
  },
  {
    path: '/next-steps',
    name: 'NextSteps',
    component: NextSteps,
    meta: {
      breadCrumb: 'Next steps',
      title: 'Next steps'
    },
    props: true
  },

  {
    path: '/about-us',
    name: 'AboutUs',
    component: AboutUs,
    meta: {
      metaTags: [
        {
          name: 'description',
          content: 'BW Legal is the UKs largest independent debt recovery law firm instructed by various clients in matters relating to debt recovery and so you may find that we are contacting you on behalf of another company about your outstanding balance. Our aim is to provide you with an affordable, ethical and fair service.'
        }
      ],
      title: 'About us'
    }
  },
  {
    path: '/hmrc',
    name: 'HMRC',
    component: HMRC,
    meta: {
      metaTags: [
        {
          name: 'description',
          content: 'BW Legal specializes in HMRC debt recovery matters. We provide expert assistance with tax debt management and resolution, offering flexible payment options and professional support throughout the process.'
        }
      ],
      title: 'HMRC'
    }
  },
  {
    path: '/business-site',
    name: 'BusinessSite',
    beforeEnter() {
      window.open('https://www.bwlegal-business.co.uk/', '_blank');
    }
  },
  {
    path: '/chat',
    name: 'Chat',
    component: ContactUs,
    meta: {
      title: 'Chat'
    }
  },
  {
    path: '/customer-portal-external',
    name: 'CustomerPortal',
    beforeEnter() {
      window.open('https://portal.bwlegal.co.uk/', '_blank');
    }
  },
  {
    path: '/customer-contact',
    name: 'CustomerContact',
    beforeEnter() {
      window.open('https://portal.bwlegal.co.uk/help', '_blank');
    }
  },  
  {
    path: '/customer-portal',
    name: 'CustomerPortalInternal',
    component: CustomerPortalInternal,
    meta: {
      breadCrumb: 'Customer portal',
      title: 'Customer portal'
    },
  },
  {
    path: '/payment-portal',
    name: 'PaymentPortal',
    beforeEnter() {
      window.open('https://payments.bwlegal.co.uk/', '_blank');
    }
  },
  {
    path: '/help',
    name: 'Help',
    component: Help,
    meta: {
      metaTags: [
        {
          name: 'description',
          content: 'We are always here to help you. We understand that managing debt can be a difficult process and so we have the tools, advice and support to guide you towards financial freedom as quickly as possible.'
        }
      ],
      breadCrumb: 'Help',
      title: 'Help'
    },
    children: [
      {
        path: 'how-can-I-pay',
        name: 'HowCanIPay',
        component: HowCanIPay,
        meta: {
          metaTags: [
            {
              name: 'description',
              content: 'You can make a one-off payment or you can set up an affordable repayment plan using a variety of payment options.'
            }
          ],          
          breadCrumb: 'How can I pay',
          title: 'How can I pay',
        },
      },
      {
        path: 'have-question',
        name: 'HaveQuestion',
        component: HaveQuestion,
        meta: {
          metaTags: [
            {
              name: 'description',
              content: 'We understand that sometimes you would prefer not to call us or wait for replies to emails so we have made it easy for you to find the answers to your questions.'
            }
          ],          
          breadCrumb: 'I have a question',
          title: 'I have a question'
        },
        children: [
          {
            path: 'faq',
            name: 'FAQ',
            component: FAQ,
            meta: {
              breadCrumb: 'General FAQs',
              title: 'General FAQs'
            },
          },
          {
            path: 'energy',
            name: 'Energy',
            component: FAQ,
            meta: {
              breadCrumb: 'Energy clients',
              title: 'Energy clients'
            },
          },
          {
            path: 'parking',
            name: 'Parking',
            component: FAQ,
            meta: {
              breadCrumb: 'Parking',
              title: 'Parking'
            },
          },
          {
            path: 'prac',
            name: 'PRAC',
            component: PRAC,
            meta: {
              breadCrumb: 'PRAC',
              title: 'PRAC'
            },
            children: [
              {
                path: 'prac-energy',
                name: 'PracEnergy',
                component: PracEnergy,
                meta: {
                  breadCrumb: 'PRAC Energy',
                  title: 'PRAC Energy'
                },
                children: [
                  {
                    path: 'occupier',
                    name: 'Occupier',
                    component: FAQ,
                    meta: {
                      breadCrumb: 'Occupier',
                      title: 'Occupier'
                    },
                  }, 
                  {
                    path: 'namedPerson',
                    name: 'NamedPerson',
                    component: FAQ,
                    meta: {
                      breadCrumb: 'Named person',
                      title: 'Named person'
                    },
                  }, 
                ]
              }, 
              {
                path: 'prac-financial',
                name: 'PracFinancial',
                component: FAQ,
                meta: {
                  breadCrumb: 'PRAC Financial',
                  title: 'PRAC Financial'
                },
              }, 
            ]
          }, 
        ]
      },
      {
        path: 'contact-us',
        name: 'ContactUs',
        component: ContactUs,
        meta: {
          breadCrumb: 'Contact us',
          metaTags: [
            {
              name: 'description',
              content: `You can ask us a question directly on the site and we will try to find the answer in an instant. If you can't find your answer in our FAQs you can still get in touch in all the usual ways.`
            }
          ],
          title: 'Contact us'
        }
      },      
      {
        path: 'seek-advice',
        name: 'SeekAdvice',
        component: SeekAdvice,
        meta: {
          breadCrumb: 'Seek advice',
          title: 'Seek advice'
        },
      },
    ]
  },
  {
    path: '/careers',
    name: 'Careers',
    beforeEnter() {
      window.open('https://www.bwlegal-business.co.uk/careers', '_blank');
    }
  },
  {
    path: '/page-not-found',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: {
      title: 'Page not found'
    }
  },
  {
    path: '/thanks',
    name: 'Thanks',
    component: Thanks,
    meta: {
      title: 'Thanks'
    }
  },
  {
    path: '/accreditations',
    name: 'Accreditations',
    component: Accreditations,
    meta: {
      title: 'Accreditations'
    }
  },
  {
    path: '/accessibility',
    name: 'Accessibility',
    component: Accessibility,
    meta: {
      title: 'Accessibility'
    }
  },
  {
    path: '/privacy-cookies',
    name: 'Privacy',
    component: Privacy,
    meta: {
      title: 'Privacy'
    }
  },
  {
    path: '/terms-of-use',
    name: 'TermsOfUse',
    component: TermsOfUse,
    meta: {
      title: 'Terms of use'
    }
  },
  {
    path: '/complaints-procedure',
    name: 'Complaints',
    component: Complaints,
    meta: {
      title: 'Complaints'
    }
  },
  {
    path: '/complaints',
    redirect: { name: 'Complaints' },
  },
  {
    path: '/faq',
    redirect: { name: 'HaveQuestion' },
  },
  {
    path: '*',
    redirect: { name: 'PageNotFound' }
  },
  {
    path: '/send-supporting-documents',
    name: 'SendSupportingDocuments',
    beforeEnter() {
      window.open('https://portal.bwlegal.co.uk/help', '_blank');
    }
  },
  {
    path: '/customers',
    redirect: { name: 'ContactUs' }
  },  
  {
    path: '/media-enquiries',
    name: 'MediaEnquiries',
    beforeEnter() {
      window.open('https://www.bwlegal-business.co.uk/media-enquiries/', '_parent');
    }
  },
  {
    path: '/customers/customer-contact/',
    redirect: { name: 'ContactUs' }
  }, 
  {
    path: '/csa-code',
    name: 'CSACode',
    beforeEnter() {
      window.open('https://www.csa-uk.com/page/codesandstandards/', '_parent');
    }
  },
  {
    path: '/customer-portal-help',
    name: 'CustomerPortalHelp',
    beforeEnter() {
      window.open('https://portal.bwlegal.co.uk/help', '_blank');
    }
  },
  {
    path: '/livechat',
    name: 'LiveChat',
    beforeEnter() {
      window.open('https://direct.lc.chat/12794583/', '_parent');
    }
  },
  {
    path: '/livechat/qr',
    name: 'LiveChatQR',
    beforeEnter() {
      window.open('https://direct.lc.chat/12794583/?source=qr', '_parent');
    }
  },
];

const router = new VueRouter({
  mode: 'history',
  base: import.meta.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.name !== 'Chat') {
      if (to.hash) {
        return { selector: to.hash, offset: { x: 0, y: 80 }, behavior: 'smooth' }

      }
      return { x: 0, y: 0, behavior: 'smooth' }
    }
  }
});

router.beforeEach((to, from, next) => {

  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  const pageTitle = to.path !== '/' ? ' - BW Legal' : '';
  window.document.title = to.meta && to.meta.title ? to.meta.title + pageTitle : '';

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  const link = document.createElement('link');

  link.rel = "canonical";
  link.href = `https://www.bwlegal.co.uk${to.path}`;
  link.setAttribute('data-vue-router-controlled', '');
  document.getElementsByTagName('head')[0].appendChild(link);

  next();
});



export default router;
